export enum FEATURED_PROGRAMS {
  TRENDING = 'trending',
  POPULAR = 'popular'
}
